import { render, staticRenderFns } from "./POrderUploadDocument.vue?vue&type=template&id=364ccb0a&scoped=true&"
import script from "./POrderUploadDocument.vue?vue&type=script&lang=js&"
export * from "./POrderUploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./POrderUploadDocument.vue?vue&type=style&index=0&id=364ccb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ccb0a",
  null
  
)

export default component.exports